//---APP
export const APP_SIZE_SET = 'APP_SIZE_SET';
export const APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE = 'APP_HEADER_SIDEBAR_SHOW_FLAG_TOGGLE';
export const APP_LOADER_FLAG_TOGGLE = 'APP_LOADER_FLAG_TOGGLE';
export const APP_POPUP_OPEN = 'APP_POPUP_OPEN';
export const APP_POPUP_CLOSE = 'APP_POPUP_CLOSE';

//---FILTERS
export const FILTERS_SCHEME_SET = 'FILTERS_SCHEME_SET';
export const FILTERS_LISTINGS_SET = 'FILTERS_LISTINGS_SET';

//---NOTIFICATIONS
export const NOTIFICATIONS_GET = 'NOTIFICATIONS_GET';
export const NOTIFICATIONS_FILTERS_SET = 'NOTIFICATIONS_FILTERS_SET';
export const NOTIFICATIONS_META_SET = 'NOTIFICATIONS_META_SET';

//---NOTES
export const NOTE_CREATE_SET = 'NOTE_CREATE_SET';
export const NOTE_GET = 'NOTE_GET';
export const NOTE_DELETE = 'NOTE_DELETE';

//---PROPERTY-INFO
export const PROPERTY_INFO_CURRENT_SET = 'PROPERTY_INFO_CURRENT_SET';

//---GOOGLE
export const GOOGLE_INIT = 'GOOGLE_INIT';
export const GOOGLE_INIT_GEOCODER = 'GOOGLE_INIT_GEOCODER';

//---AUTH
export const AUTH_LOADING_SET = 'AUTH_LOADING_SET';
export const AUTH_PTF_TOKEN_SET = 'AUTH_PTF_TOKEN_SET';
export const AUTH_ROUTES_SET = 'AUTH_ROUTES_SET';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR_SET = 'AUTH_ERROR_SET';
export const AUTH_USER_SET = 'AUTH_USER_SET';

//---DASHBOARD
export const DASHBOARD_LIST_GET = 'DASHBOARD_LIST_GET';
export const DASHBOARD_LIST_META_SET = 'DASHBOARD_LIST_META_SET';
export const DASHBOARD_REALTY_LIST_GET = 'DASHBOARD_REALTY_LIST_GET';
export const DASHBOARD_ANALYST_LIST_GET = 'DASHBOARD_ANALYST_LIST_GET';
export const DASHBOARD_PROPERTY_SET = 'DASHBOARD_PROPERTY_SET';
export const DASHBOARD_PROPERTY_REPORT_UPDATE = 'DASHBOARD_PROPERTY_REPORT_UPDATE';

//---FILES
export const FILES_SET = 'FILES_SET';
